export default "__VITE_ASSET__BdCZSIdl__"